<template>
  <a-card class="home-menu-page" >
    <template slot="title">
      <div class="home-menu-card_title">{{ menuName }}</div>
    </template>
    <a-menu class="home-menu-style"
            :key="menuKey"
            :selectedKeys="selectMenu"
            :openKeys.sync="openMenu">
      <template v-for="item in menuList">
        <a-menu-item :title="$dt(item,'MENU_NAME')" v-if="item.isLeaf" :key="item.ASSEMBLY" @click="$goPath(item)">
          <a-icon v-if="item.MENU_IMAGE" :type="item.MENU_IMAGE" />
          <span class="home-menu-group" v-if="!menuCollapseFlag">{{ $dt(item,'MENU_NAME') }}</span>
        </a-menu-item>
        <sub-menu v-else :key="item.ASSEMBLY" :menu-info="item" :menu-collapse-flag="menuCollapseFlag" />
      </template>
    </a-menu>
  </a-card>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "home-menu",
  props: {
    routePath: {}
  },
  data(){
    return{
      openMenu: [],
      curSubMenuCode: '',
      menuCollapse: false,
      menuKey:0,
      menuName: ''
    }
  },
  watch:{
    $route() {
      let pathArray = this.$route.path.split('/');
      let fullPath = '';
      pathArray.forEach((path, index) => {
        if(index > 0 && index < pathArray.length - 1){
          fullPath += '/' + path;
          if(!this.openMenu.find(item => item === fullPath)){
            this.openMenu.push(fullPath);
          }
        }
      });
    },
    '$i18n.locale'(){
      ++this.menuKey;
      let firstMenu = this.menuTree.find(item => new RegExp('^' + item.ASSEMBLY + '/').test(this.$route.path));
      if(firstMenu) {
        this.menuName = this.$dt(firstMenu,'MENU_NAME');
      }
    }
  },
  computed:{
    ...mapState(['menuTree']),
    menuCollapseFlag() {
      if (this.menuList?.length > 0) {
        return this.menuCollapse;
      } else {
        return true;
      }
    },
    menuList(){
      let firstMenu = this.menuTree.find(item => new RegExp('^' + item.ASSEMBLY + '/').test(this.$route.path));
      if(firstMenu) {
        this.menuName = this.$dt(firstMenu,'MENU_NAME');
      }
      return firstMenu?.children;
    },
    selectMenu: {
      get() {
        return [this.$route.path];
      },
      set() {

      },
    },
  },
  methods:{
    linkPage({ key }) {
      if (this.$route.path !== key) this.$router.push(key);
    },
    toggleCollapse() {
      this.openMenu = [];
      this.menuCollapse = !this.menuCollapse;
    }
  },
  mounted() {

  },
  created() {
    let firstMenu = this.menuTree.find(item => new RegExp('^' + item.ASSEMBLY + '/').test(this.$route.path));
    if(firstMenu) {
      this.menuName = this.$dt(firstMenu,'MENU_NAME');
    }
  }
}
</script>

<style lang="scss">
.ant-card.home-menu-page{
  width: 200px;
  .ant-card-head{
    width: 200px;
    border-bottom: 2px solid #DFEFFF;
  }
  .home-menu-card_title{
    text-align: center;
  }
  .home-menu-style{
    margin: -24px;
    border-right: 0;

    .home-menu-group{
      font-size: 12px;font-weight: 400;
    }

    .ant-menu-item{
      margin: 0;
      padding-left: 32px;
    }
    .ant-menu-item-selected{
      padding-left: 28px;
      background-color: #e6f7ff;
      border-left: 4px solid #2771BC;
    }
  }
}
</style>